// @todo: Migrate to 'DropdownMenu' from @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import * as DropdownMenu from '@wandb/weave/components/DropdownMenu';
import React from 'react';

import {
  OverflowMenu,
  OverflowMenuItem,
} from '../../Views/components/OverflowMenu';
import {useWorkspaceSettingsContext} from '../../WorkspaceDrawer/Settings/WorkspaceSettingsContextProvider';
import {useClearPanels} from '../hooks/useClearPanels';
import {usePanelBankSectionsActions} from '../hooks/usePanelBankSectionsActions';

export const PanelBankControlsOverflowMenu = () => {
  const {openAllSections, closeAllSections} = usePanelBankSectionsActions();
  const onClearAllPanels = useClearPanels();

  const {
    workspaceLayout: {shouldAutoGeneratePanels},
  } = useWorkspaceSettingsContext();
  const shouldShowClearAll = shouldAutoGeneratePanels === false;

  return (
    <OverflowMenu
      aria-label="More actions..."
      data-test="pb-overflow-menu-trigger"
      variant="secondary">
      <OverflowMenuItem
        aria-label="Expand all sections"
        data-test="expand-all-sections"
        icon="expand-uncollapse"
        displayName="Expand all sections"
        onSelect={openAllSections}
      />
      <OverflowMenuItem
        aria-label="Collapse all sections"
        data-test="collapse-all-sections"
        icon="collapse"
        displayName="Collapse all sections"
        onSelect={closeAllSections}
      />
      {shouldShowClearAll && (
        <>
          <DropdownMenu.Separator />
          <OverflowMenuItem
            icon="clear-all"
            displayName="Clear all panels"
            tooltipContent="Clear all panels and rebuild your workspace from scratch."
            onSelect={onClearAllPanels}
          />
        </>
      )}
    </OverflowMenu>
  );
};
